import { BaseComponent } from '@app/core/bases/base-component/base.component';

export abstract class AbstractModalBase extends BaseComponent {

	translationPath = 'modals';

	protected constructor() {
		super();
	}

	abstract abort();

	abstract confirm();
}
